// eslint-disable-next-line no-restricted-imports
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import * as React from "react";
import { preload } from "react-dom";
import { getDefaultImageUrl, getNormalizedImageUrls } from "@faire/retailer/components/Image/ProgressiveProductImage";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import * as styles from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/aspectRatioPictureByWidthNoBorder.css";
import { ImageOverlay } from "@faire/retailer/features/MarketplaceItems/ImageOverlay";
import { VERTICAL_ASPECT_RATIO } from "@faire/retailer/lib/verticalAspectRatio";
export var ProductImageWithSrcsetSizes = function(param) {
    var image = param.image, alt = param.alt, sizes = param.sizes, showVerticalImagery = param.showVerticalImagery, extraProductsCount = param.extraProductsCount, smallCount = param.smallCount, loading = param.loading, onLoad = param.onLoad, _param_addOverlay = param.addOverlay, addOverlay = _param_addOverlay === void 0 ? true : _param_addOverlay;
    var dataTestId = "product-image".concat(showVerticalImagery ? "-vertical" : "");
    var normalizedUrls = getNormalizedImageUrls(image, showVerticalImagery, {});
    var src = getDefaultImageUrl(image, showVerticalImagery, {});
    preload(src, {
        as: "image"
    });
    var _obj;
    return /*#__PURE__*/ _jsxs("picture", {
        className: styles.aspectRatioPictureByWidthNoBorder,
        style: assignInlineVars((_obj = {}, _define_property(_obj, styles.width, "100%"), _define_property(_obj, styles.ratio, "".concat(showVerticalImagery ? VERTICAL_ASPECT_RATIO : 1)), _obj)),
        "data-test-id": dataTestId,
        children: [
            /*#__PURE__*/ _jsx("source", {
                srcSet: normalizedUrls,
                sizes: sizes
            }),
            /*#__PURE__*/ _jsx("img", {
                src: src,
                alt: alt,
                loading: loading,
                "data-product-image": "full",
                onLoad: onLoad
            }),
            addOverlay ? /*#__PURE__*/ _jsx(ImageOverlay, {
                extraProductsCount: extraProductsCount,
                smallCount: smallCount
            }) : null
        ]
    });
};
